import styled from '@emotion/styled'
import { colors, fontFamilies } from '@configs/styles/config'

export const SectionWrapper = styled.section`
  width: 100%;
  background: #130b28;
  color: ${colors.uguWhite};
  padding: 4.5rem 1rem 3.5rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Container = styled.div`
  width: 100%;
  max-width: 1314px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3.5rem;
`

export const TopRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 2rem;
  @media (max-width: 900px) {
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 2.5rem;
  }
`

export const Profile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.1rem;
  min-width: 220px;
`

export const Avatar = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  background: ${colors.uguLightGrey};
`

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const ProfileName = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  font-family: ${fontFamilies.sofiaPro}, ${fontFamilies.inter}, sans-serif;
`

export const ProfileRole = styled.div`
  font-size: 0.98rem;
  color: ${colors.uguLightGrey};
  font-family: ${fontFamilies.inter}, sans-serif;
`

export const Quote = styled.div`
  flex: 1;
  font-size: 2.5rem;
  line-height: 1.18;
  text-align: left;
  font-family: ${fontFamilies.semiBold};
  max-width: 800px;
  @media (max-width: 900px) {
    text-align: left;
    font-size: 2rem;
  }
`

export const StatsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-top: 2.5rem;
  flex-wrap: wrap;
  gap: 1rem;
  @media (max-width: 1224px) {
    justify-content: center;
    gap: 2rem;
  }
`

export const StatCard = styled.div`
  min-width: 300px;
  max-width: 300px;
  width: 300px;
  height: 300px;
  aspect-ratio: 1/1;
  background: transparent;
  border: 1px solid #3f4996;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 1.25rem;
  gap: 1.2rem;
  position: relative;
  font-family: ${fontFamilies.medium};
`

export const StatIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
`
